import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';
import { ValidateService } from '../../../../../@core/utils/validate.service';
import { ImprovementPlanProcess, ImprovementItem, EvaluationMethod } from '../models';
import { User } from '../../../../../@core/auth/models';

@Component({
  selector: 'improvement-plan-process',
  templateUrl: './improvement-plan-process.component.html',
  styleUrls: ['./improvement-plan-process.component.scss'],
  providers: [ValidateService],
})
export class ImprovementPlanProcessComponent implements OnInit, OnDestroy {
  @Input() public process: ImprovementPlanProcess = {} as ImprovementPlanProcess;
  loaded: boolean;
  @Input() public editable: boolean = true;
  @Input() public fireValidationAlerts: boolean = false;
  @Input() position: number = 0;
  @Output() processValid = new EventEmitter<boolean>();
  @Input() public reference: any;
  selectedRefernece: any[] = [];
  constructor(private validationService: ValidateService) {}
  config = {
    displayKey: 'description', // if objects array passed which key to be displayed defaults to description
    search: true, // true/false for the search functionlity defaults to false,
    height: 'auto', // height of the list so that if there are mor
    customComparator: () => {}, // a custom function using which user wants to sort the items.
    // default is undefined and Array.sort() will be used in that case,
    // limitTo: this.options.length, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'لا يوجد نتائج !', // text to be displayed when no items are found while searching
    searchPlaceholder: 'نوع المستفيدين', // label thats displayed in search input,
    searchOnKey: 'name', // key on which search should be performed this will be selective search.
    clearOnSelection: false, // clears search criteria when an option is selected if set to true, default is false
    inputDirection: 'ltr',
    placeholder: 'نوع المستفيدين',
    // the direction of the search input can be rtl or ltr(default)
  };
  ngOnInit() {
    this.initValidation();
    this.process.user = new User();
    this.process.userId = 2;
    this.process.selectedRefernece = [];

    if (typeof this.process.startDate === 'undefined' || Date.parse(this.process.startDate.toString()) === NaN) {
      this.process.startDate = new Date();
    }
    if (typeof this.process.endDate === 'undefined' || Date.parse(this.process.endDate.toString()) === NaN) {
      this.process.endDate = new Date();
      this.loaded = true;
    }
  }
  setDate(prop: string, event) {
    this.process[prop] = event;
  }

  //#region data Binding
  get_Resources() {
    return this.process.requiredResources
      ? this.process.requiredResources.map((x) => {
          return { id: x.id, value: x.name };
        })
      : [];
  }
  onChange_Resources(data: any[]) {
    this.process.requiredResources = data.map((x) => {
      return { id: x.id, name: x.value } as ImprovementItem;
    });
  }
  get_EvaluationMethods() {
    return this.process.evaluationMethods
      ? this.process.evaluationMethods.map((x) => {
          return { id: x.id, value: x.text };
        })
      : [];
  }
  onChange_EvaluationMethods(data: any[]) {
    this.process.evaluationMethods = data
      .filter((x) => x.value)
      .map((x) => {
        return { id: x.id, text: x.value } as EvaluationMethod;
      });
  }
  get_Risks() {
    return this.process.risk
      ? this.process.risk.split('//').map((x, i) => {
          return { id: i, value: x };
        })
      : [];
  }
  onChange_Risks(data: any[]) {
    this.process.risk = data
      .map((x) => {
        return x.value;
      })
      .join('//');
  }
  changeSelectedUser(user) {
    this.process.user = user;
    this.isInputValid('userId', user !== undefined);
  }
  //#endregion

  //#region Validation
  private subscription: ISubscription;
  valid: boolean;

  initValidation() {
    this.validationService.registerForm([
      'name',
      'userId',
      'relativeWeight',
      'requiredResources',
      'processTarget',
      'risks',
    ]);
    // subscribe to the validation service's validStatus to update your local flag
    this.subscription = this.validationService.validStatus.subscribe((status) => {
      this.valid = status;
      this.processValid.emit(status);
    });
  }

  isInputValid(name: string, status: boolean) {
    this.validationService.updateFormFlag(name, status);
  }

  ngOnDestroy() {
    // very important
    this.subscription.unsubscribe();
  }
  //#endregion
}
